<template>
  <div class="h-100" style="min-height: 1px">
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeDownShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <b-row>
              <b-col md="5">
                <b-card class="card-shadow mb-4" no-body>
                  <b-card-body>
                    <b-nav class="nav-sub nav-sm mt-n1 mb-3" justified>
                      <b-nav-item
                        :active="profile === 'consumption'"
                        @click="profile = 'consumption'"
                      >
                        <div>Činný odber</div>
                        <b-skeleton-wrapper
                          :loading="calLoading"
                          class="d-flex align-items-center justify-content-center"
                        >
                          <template #loading>
                            <b-skeleton
                              variant="primary"
                              class="mb-0"
                              height="20.4px"
                              width="50%"
                            />
                          </template>
                          <b-badge variant="primary" class="fs-base">
                            {{ totalConsumption | formatNumber(2) }} kWh
                          </b-badge>
                        </b-skeleton-wrapper>
                      </b-nav-item>
                      <b-nav-item
                        :active="profile === 'idleConsumption'"
                        @click="profile = 'idleConsumption'"
                      >
                        <div>Jalový odber</div>
                        <b-skeleton-wrapper
                          :loading="calLoading"
                          class="d-flex align-items-center justify-content-center"
                        >
                          <template #loading>
                            <b-skeleton
                              variant="primary"
                              class="mb-0"
                              height="20.4px"
                              width="50%"
                            />
                          </template>
                          <b-badge variant="primary" class="fs-base">
                            {{ totalIdleConsumption | formatNumber(2) }} kVArh
                          </b-badge>
                        </b-skeleton-wrapper>
                      </b-nav-item>
                      <b-nav-item
                        :active="profile === 'idleSupply'"
                        @click="profile = 'idleSupply'"
                      >
                        <div>Jalová dodávka</div>
                        <b-skeleton-wrapper
                          :loading="calLoading"
                          class="d-flex align-items-center justify-content-center"
                        >
                          <template #loading>
                            <b-skeleton
                              variant="primary"
                              class="mb-0"
                              height="20.4px"
                              width="50%"
                            />
                          </template>
                          <b-badge variant="primary" class="fs-base">
                            {{ totalIdleSupply | formatNumber(2) }} kVArh
                          </b-badge>
                        </b-skeleton-wrapper>
                      </b-nav-item>
                    </b-nav>
                    <b-overlay :blur="null" :opacity="0.5" :show="calLoading">
                      <calendar
                        v-model="activeDate"
                        @monthChanged="changeDate"
                        @onDelete="removeDays"
                      >
                        <template
                          v-for="(d, i) in monthData"
                          #[`cell(${d.date})`]="{ day }"
                        >
                          <template v-if="day.isCurrentMonth">
                            <div
                              v-if="
                                profile === 'consumption' &&
                                d.overflows &&
                                (d.overflows.rk > 0 || d.overflows.mrk > 0)
                              "
                              class="over-icon"
                            >
                              {{ d.overflows.rk + d.overflows.mrk }}
                            </div>
                            <b-icon
                              :class="{
                                'text-danger': d[profile + 'State'] === 0,
                                'text-warning': d[profile + 'State'] === 1,
                                'text-success': d[profile + 'State'] === 2,
                              }"
                              icon="dot"
                              scale="2x"
                            />
                            <transition-group
                              :key="i"
                              name="fadeUpShort"
                              tag="div"
                            >
                              >
                              <div
                                v-if="
                                  !delayedData && d[`${profile}State`] !== 0
                                "
                                :key="`item-${i}`"
                                :style="
                                  d[profile] && d[`${profile}State`] > 1
                                    ? 'background-color:' +
                                      interpolateColors[d.date].color
                                    : ''
                                "
                                class="fs-sm my-1 px-1"
                              >
                                {{ d[profile] | formatNumber(2) }}
                              </div>
                            </transition-group>
                          </template>
                        </template>
                      </calendar>
                    </b-overlay>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col md="7">
                <transition mode="out-in" name="fadeDownShort">
                  <b-card
                    v-if="monthData.length"
                    key="1"
                    class="card-shadow mb-4"
                    header-class="bg-white"
                    no-body
                  >
                    <b-card-body>
                      <b-tabs
                        nav-class="nav-sub nav-sm mt-n1 mb-3"
                        no-nav-style
                        @input="$vuebar.refreshScrollbar($refs.scroll, {})"
                      >
                        <b-tab active title="Graf">
                          <day-chart
                            v-if="dayChart.length"
                            :day-chart="chartData(dayChart)"
                            :day-data="dayData"
                            :profile="profile"
                          />
                        </b-tab>
                        <b-tab title="Intervalové data">
                          <client-table
                            v-if="Object.keys(dayData).length"
                            table-class="table-sm"
                            :columns="tableInt.columns"
                            :data="dayData.values"
                            :searchable="false"
                            :sort-by.sync="tableInt.sortBy"
                            bordered
                            striped
                          >
                            <template #cell(consumption)="data">
                              <template v-if="profile === 'consumption'">
                                <template v-if="data.value !== null">
                                  {{ data.value | formatNumber(2) }}
                                </template>
                                <template v-else> -</template>
                              </template>
                              <template v-else>
                                <template v-if="data.item[profile] !== null">
                                  {{ data.item[profile] | formatNumber(2) }}
                                </template>
                                <template v-else> -</template>
                              </template>
                            </template>
                            <template #cell(state)="data">
                              <b-badge
                                v-if="data.item[profile + 'State'] == 0"
                                class="fs-sm"
                                variant="danger"
                              >
                                Neplatná hodnota
                              </b-badge>
                              <b-badge v-else class="fs-sm" variant="success">
                                Platná hodnota
                              </b-badge>
                            </template>
                          </client-table>
                        </b-tab>
                        <b-tab title="Nameraná hodinová práca">
                          <client-table
                            v-if="
                              hourlyWork[activeDate] &&
                              hourlyWork[activeDate].length
                            "
                            table-class="table-sm"
                            :columns="tableHourWork.columns"
                            :data="hourlyWork[activeDate]"
                            :searchable="false"
                            :sort-by.sync="tableHourWork.sortBy"
                            bordered
                            striped
                          />
                        </b-tab>
                        <b-tab
                          v-if="profile === 'consumption'"
                          title="Prekročenia"
                        >
                          <client-table
                            v-if="Object.keys(data).length"
                            table-class="table-sm"
                            :columns="tableOver.columns"
                            :data="overData"
                            :searchable="false"
                            :sort-by.sync="tableOver.sortBy"
                            bordered
                            striped
                          >
                            <template #cell(overRK)="data">
                              <template
                                v-if="data.item.consumption > dayData.RK"
                              >
                                <template
                                  v-if="data.item.consumptionLoss != null"
                                >
                                  {{
                                    (data.item.consumptionLoss - dayData.RK)
                                      | formatNumber(2)
                                  }}
                                </template>
                                <template v-else>
                                  {{
                                    (data.item.consumption - dayData.RK)
                                      | formatNumber(2)
                                  }}
                                </template>
                              </template>
                              <template v-else> -</template>
                            </template>
                            <template #cell(overMRK)="data">
                              <template
                                v-if="
                                  data.item.consumption > dayData.MRK &&
                                  data.item.consumptionLoss - dayData.MRK > 0
                                "
                              >
                                <template
                                  v-if="data.item.consumptionLoss != null"
                                >
                                  {{
                                    (data.item.consumptionLoss - dayData.MRK)
                                      | formatNumber(2)
                                  }}
                                </template>
                                <template v-else>
                                  {{
                                    (data.item.consumption - dayData.MRK)
                                      | formatNumber(2)
                                  }}
                                </template>
                              </template>
                              <template v-else> -</template>
                            </template>
                          </client-table>
                        </b-tab>
                      </b-tabs>
                    </b-card-body>
                  </b-card>
                  <div v-else-if="!calLoading" key="2" class="text-center my-3">
                    <div class="mb-3">
                      <b-icon font-scale="5" icon="question-diamond" />
                    </div>
                    <h2 class="mb-3">
                      V danom období neboli nájdené žiadne dáta
                    </h2>
                  </div>
                </transition>
              </b-col>
            </b-row>
            <transition name="fadeUpShort">
              <total-chart
                v-if="totalData.length"
                v-model="totalChartType"
                :date="currentDate"
                :loading="totalLoading"
                :profile="profile"
                :total-chart="chartData(totalData)"
              />
            </transition>
          </div>
        </div>
      </transition>
    </b-overlay>
  </div>
</template>
<script>
import ClientTable from '@/components/ClientTable'
import Calendar from '@/components/Calendar'
import DayChart from './DayChart'
import TotalChart from './TotalChart'
import collect from 'collect.js'

export default {
  components: {
    ClientTable,
    Calendar,
    DayChart,
    TotalChart,
  },
  data() {
    return {
      date: { ge: null, lt: null },
      data: [],
      hourlyWork: {},
      totalData: [],
      profile: 'consumption',
      totalChartType: 'month',
      loading: false,
      calLoading: false,
      delayedData: false,
      totalLoading: false,
      currentDate: {
        year: this.$moment().year(),
        month: parseInt(this.$moment().subtract('1', 'day').format('MM')),
      },
      activeDate: this.$moment().subtract('1', 'day').format('YYYY-MM-DD'),
      tableInt: {
        columns: [
          {
            key: 'measured_at',
            label: 'Čas',
            sortable: true,
          },
          {
            key: 'consumption',
            label: 'Hodnota',
            class: 'text-right',
            tdClass: 'text-nowrap',
            sortable: true,
          },
          {
            key: 'state',
            label: 'Status',
            tdClass: 'text-nowrap',
            sortable: true,
          },
        ],
        sortBy: 'measured_at',
      },
      tableHourWork: {
        columns: [
          {
            key: 'time',
            label: 'Čas od',
          },
          {
            key: 'consumption',
            label: 'Nameraná práca',
            class: 'text-right',
            tdClass: 'text-nowrap',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 2)
                : '-',
          },
        ],
        sortBy: 'time',
      },
      tableOver: {
        columns: [
          {
            key: 'measured_at',
            label: 'Čas',
            sortable: true,
          },
          {
            key: 'consumption',
            label: 'Hodnota',
            class: 'text-right',
            tdClass: 'text-nowrap',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 2)
                : '-',
            sortable: true,
          },
          {
            key: 'overRK',
            label: 'Prekročenie RK',
            class: 'text-right',
            tdClass: 'text-nowrap',
            sortable: true,
          },
          {
            key: 'overMRK',
            label: 'Prekročenie MRK',
            class: 'text-right',
            tdClass: 'text-nowrap',
            sortable: true,
          },
        ],
        sortBy: 'measured_at',
      },
    }
  },
  computed: {
    interpolateColors() {
      let gradient = [
        '#BCDDF5',
        '#B7DAF4',
        '#B2D8F3',
        '#AED5F3',
        '#A9D3F2',
        '#A4D1F1',
        '#A0CEF1',
        '#9BCCF0',
        '#96CAEF',
        '#92C7EF',
        '#8DC5EE',
        '#88C2ED',
        '#84C0ED',
        '#7FBEEC',
        '#7ABBEB',
        '#76B9EB',
        '#71B7EA',
        '#6CB4E9',
        '#68B2E9',
        '#63B0E8',
        '#5EADE7',
        '#5AABE7',
        '#55A8E6',
        '#50A6E5',
        '#4CA4E5',
        '#47A1E4',
        '#429FE3',
        '#3E9DE3',
        '#399AE2',
        '#3498E1',
        '#3096E1',
      ]
      return collect(this.monthData)
        .sortBy(this.profile)
        .map((item, i) => {
          return {
            date: item.date,
            value: item[this.profile],
            color: gradient[i],
          }
        })
        .keyBy('date')
        .all()
    },
    dayData() {
      let output = []
      output = this.data.filter((today) => {
        return today.date === this.activeDate
      })
      let data = {}
      if (output.length) {
        if (this.profile === 'consumption') {
          data.MRK = output[0].reservedCapacity
            ? output[0].reservedCapacity.mrk
            : null
          data.RK = output[0].reservedCapacity
            ? output[0].reservedCapacity.rk
            : null
        }
        data.values = output[0].values ? output[0].values : []
        data.activeDate = this.activeDate
      }
      return data
    },
    monthData() {
      return this.data
        .map((i) => {
          let filtered = { ...i }
          delete filtered.values
          return filtered
        })
        .filter((item) => {
          return (
            parseInt(this.$moment(item.date, 'YYYY-MM-DD').format('MM')) ===
            this.currentDate.month
          )
        })
    },
    dayChart() {
      let data = []
      data = this.filteredData.filter((today) => {
        let before = this.$moment(this.activeDate)
          .subtract(1, 'day')
          .format('YYYY-MM-DD')
        let now = this.$moment(this.activeDate).format('YYYY-MM-DD')
        let after = this.$moment(this.activeDate)
          .add(1, 'day')
          .format('YYYY-MM-DD')
        return today.date == before || today.date == now || today.date == after
      })
      return data
    },
    overData() {
      let output = []
      if (Object.keys(this.dayData).length) {
        output = this.dayData.values.filter((item) => {
          return item.consumptionOverflowState >= 1
        })
      }
      return output
    },
    filteredData() {
      return this.filtered('data')
    },
    filteredTotal() {
      return this.filtered('totalData')
    },
    totalConsumption() {
      return this.monthData.reduce((sum, item) => item.consumption + sum, 0)
    },
    totalIdleConsumption() {
      return this.monthData.reduce((sum, item) => item.idleConsumption + sum, 0)
    },
    totalIdleSupply() {
      return this.monthData.reduce((sum, item) => item.idleSupply + sum, 0)
    },
  },
  watch: {
    totalChartType(val) {
      if (val === 'month') {
        this.fetchData(true)
      } else {
        this.fetchYear()
      }
    },
  },
  mounted() {
    this.$root.$on('reports.reloadIntervalData', this.reload)
  },
  beforeDestroy() {
    this.$root.$off('reports.reloadIntervalData')
  },
  created() {
    this.loading = true
    this.$api
      .get(
        `reports/${this.$route.params.energetics_id}/interval/get_power_last_date`,
      )
      .then((res) => {
        if (!res.data.data) {
          this.loading = false
          return false
        }
        let date = this.$moment(res.data.data)
        this.currentDate = {
          year: parseInt(date.format('YYYY')),
          month: parseInt(date.format('MM')),
        }
        this.activeDate = date.format('YYYY-MM-DD')
        this.fetchData()
        this.getPowerHourlyWork()
      })
  },
  methods: {
    reload() {
      this.fetchData()
      this.getPowerHourlyWork()
    },
    fetchData(silent = false) {
      this.loading = !silent
      this.delayedData = true
      this.$api
        .get(
          `reports/${this.$route.params.energetics_id}/interval/get_power_data`,
          {
            params: {
              year: this.currentDate.year,
              month: this.currentDate.month,
            },
          },
        )
        .then((res) => {
          this.data = res.data
          if (!silent) {
            this.loading = false
          }
          this.calLoading = false
          setTimeout(() => {
            this.delayedData = false
          }, 100)
          if (this.totalChartType === 'month') {
            this.totalData = res.data.filter((month) => {
              return (
                this.$moment(month.date).format('MM') == this.currentDate.month
              )
            })
          }
        })
    },
    fetchYear(silent = false) {
      this.totalLoading = !silent
      this.$api
        .get(
          `reports/${this.$route.params.energetics_id}/interval/get_power_data`,
          {
            params: {
              year:
                this.totalChartType === 'prevyear'
                  ? this.$moment().subtract(1, 'year').year()
                  : this.currentDate.year,
            },
          },
        )
        .then((res) => {
          this.totalData = res.data
          if (!silent) {
            this.totalLoading = false
          }
        })
    },
    getPowerHourlyWork() {
      this.$api
        .get(
          `reports/${this.$route.params.energetics_id}/interval/get_power_hourly_work`,
          {
            params: {
              year: this.currentDate.year,
              month: this.currentDate.month,
            },
          },
        )
        .then((res) => {
          this.hourlyWork = res.data
        })
    },
    changeDay(val) {
      this.activeDate = this.$moment(val).format('YYYY-MM-DD')
    },
    changeDate(date) {
      this.currentDate.year = date.year()
      this.currentDate.month = date.month() + 1

      this.data = []

      this.calLoading = true
      this.fetchData(true)
      this.getPowerHourlyWork()
    },
    removeDays(days) {
      if (!days.length) return

      this.$swal({
        title: 'Ste si istý?',
        html: 'Skutočne chcete odstrániť uvedené dni?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api
            .delete(
              `reports/${this.$route.params.energetics_id}/interval/delete`,
              {
                data: {
                  days: days,
                },
              },
            )
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.message,
                timer: 5000,
              })
              this.reload()
            })
        }
      })
    },
    chartData(data = []) {
      if (data.length) {
        data = collect(data).sortBy('date').all()
        let output = {
          mrk: [],
          rk: [],
          values: [],
        }
        data.forEach((day, i) => {
          if (day.values) {
            day.values.forEach((val, vi) => {
              let date = this.$moment(
                day.date + ' ' + val.measured_at,
              ).valueOf()
              if (!output.mrk[i]) {
                output.mrk[i] = []
              }
              if (!output.rk[i]) {
                output.rk[i] = []
              }
              if (!output.values[i]) {
                output.values[i] = []
              }
              if (this.profile === 'consumption') {
                output.mrk[i][vi] = {
                  x: date,
                  y: day.reservedCapacity ? day.reservedCapacity.mrk : null,
                }
                output.rk[i][vi] = {
                  x: date,
                  y: day.reservedCapacity ? day.reservedCapacity.rk : null,
                }
              }
              output.values[i][vi] = {
                x: date,
                y:
                  this.profile === 'consumption'
                    ? val.consumptionLoss
                      ? val.consumptionLoss
                      : val.consumption
                    : val[this.profile],
              }
            })
          }
        })
        output['mrk'] = output.mrk.reduce((p, n) => p.concat(n), [])
        output['rk'] = output.rk.reduce((p, n) => p.concat(n), [])
        output['values'] = output.values.reduce((p, n) => p.concat(n), [])
        return output
      } else {
        return {}
      }
    },
    filtered(type) {
      let data = []
      data = this[type].map((item) => {
        let filtered = { ...item }
        filtered.values = item.values.filter(
          (val) =>
            parseInt(this.$moment(val.measured_at, 'HH:mm:ss').format('ss')) ===
            0,
        )
        return filtered
      })
      return data
    },
  },
}
</script>
